<template>
  <div :data-clazz="model.clazz">
    <div class="panelTitle">{{ i18n['sequenceFlow'] }}</div>
    <div class="panelBody">
      <DefaultDetail :model="model" :on-change="onChange" :read-only="readOnly" />
      <div class="panelRow">
        <div>
          <span style="color: red">*</span> 属性：
        </div>
        <a-select
          :disabled="readOnly"
          :value="model.flowProperties"
          @change="(e) => onChange('flowProperties', e)"
          placeholder="选择流转属性"
          style="width:90%; font-size:12px"
        >
          <a-select-option value="1">同意</a-select-option>
          <a-select-option value="0">拒绝</a-select-option>
          <a-select-option value="2">其他</a-select-option>
        </a-select>
      </div>
      <div class="panelRow">
        <a-checkbox
          :checked="model.isExecuteTask"
          :disabled="readOnly"
          @input="(value) => onChange('isExecuteTask', value)"
        >是否执行任务</a-checkbox>
      </div>
      <div class="panelRow">
        <div>{{ i18n['sequenceFlow.expression'] }}：</div>
        <a-textarea
          :disabled="readOnly"
          :rows="4"
          :value="model.conditionExpression"
          @input="(value) => {onChange('conditionExpression', value)}"
          style="width:90%; font-size:12px"
        />
      </div>
    </div>
  </div>
</template>
<script>
  import DefaultDetail from './DefaultDetail'
  export default {
    name: 'FlowDetail',
    inject: ['i18n'],
    components: {
      DefaultDetail
    },
    props: {
      model: {
        type: Object,
        default: () => ({})
      },
      onChange: {
        type: Function,
        default: () => { }
      },
      readOnly: {
        type: Boolean,
        default: false
      }
    }
  }
</script>
